import { CloudActions, UserAdminServiceUrls } from '@portal/portal-core';
import { call, put } from 'redux-saga/effects';
import { sendAction } from '../utils';

interface AdminClientConfig {
  baseApiUrl: string;
  getAuthToken: () => string;
}

interface ForceUpdateAction {
  payload: {
    userId: string;
    costCenterId: string;
  };
}

interface SendActionResponse {
  succeeded?: boolean;
  data?: {
    costCenter?: unknown;
  };
}

export function* adminSyncForceUpdate(
  config: AdminClientConfig,
  action: ForceUpdateAction,
  timeout = 5000,
): Generator<unknown, void, unknown> {
  const { userId } = action.payload;
  const url = UserAdminServiceUrls.userAdminSyncURL(config.baseApiUrl, action.payload.userId);
  const costCenterPayload = { id: action.payload.costCenterId, version: 0 };
  // users can be empty objects
  const users = {};
  const serverAction = CloudActions.syncUserAdmin(userId, costCenterPayload, users);
  try {
    const response = (yield call(sendAction, config, serverAction, url, timeout)) as SendActionResponse;
    const { succeeded, data } = response;
    if (succeeded) {
      // update the cost center slice
      const { costCenter } = data ?? {};
      yield put(CloudActions.syncUserAdminCostCenter(userId, costCenter));
    }
  } catch (error) {
    console.error(error);
  }
}
